export class DataAcaoJudicialModel {

    constructor(
        public dtAcaoJudicial?: string,
        public nrAnoProc?: string,
        public nrProc1?: string,
        public nrProc2?: string,
        public nrProc3?: string,
        public dvProc?: string,
        public dsVara?: string
    ) {
    }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/models/data-acao-judicial.model.ts